var _defs, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpgradeVoidBlade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 560 560",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #78fff2;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M97.54,229.48l389.66,36.43,10.6,4.12H40.32l57.23-40.56M94.78,219.18l-85.87,60.86h542.17l-61.55-23.95-394.75-36.91h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M497.81,289.96l-10.6,4.12-389.66,36.43-57.23-40.56h457.49M551.08,279.96H8.92l85.87,60.86,394.75-36.91,61.55-23.95h0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeVoidBlade);
export default __webpack_public_path__ + "static/media/upgrade-void-blade.e57714fe1e039949e7656524ad8b4692.svg";
export { ForwardRef as ReactComponent };